module.exports = __webpack_public_path__ + "img/Costa Rica.e1172ee8.svg";